import {urlSanitiser} from "../httpUrlTrimmer"
import env from "../../config/env"
import {createHeadingHtml, esiCountTotalResultsHtml} from "../createHeadingHtml"

const {REACT_APP_SEO_METADATA_BASEURL, REACT_APP_SERVE_PATH_PREFIX} = env

const headingEsiBaseUrl = (SITEURL: string, useDevEsi: boolean) =>
    REACT_APP_SEO_METADATA_BASEURL && useDevEsi ? REACT_APP_SEO_METADATA_BASEURL + REACT_APP_SERVE_PATH_PREFIX : SITEURL

export default function createHeadingEsiTag(
    siteUrl: string,
    useDevEsi: boolean,
    url: string,
    totalResults: number,
    title: string,
    showTotalResultsInEsiExcept: boolean,
) {
    const sanitisedUrl = urlSanitiser(url)
    const encodedUrl = encodeURIComponent(sanitisedUrl.replace(urlSanitiser(siteUrl), ""))

    const esiInclude = `<esi:include src="${headingEsiBaseUrl(
        siteUrl,
        useDevEsi,
    )}/seo/seo-headings?urlPath=${encodedUrl}"/>`

    const fallbackHeadingHtml = createHeadingHtml(totalResults, title, showTotalResultsInEsiExcept)

    const esiWrapper = `<esi:try>
        <esi:attempt>
            ${esiInclude}
            ${esiCountTotalResultsHtml(totalResults)}
        </esi:attempt>
        <esi:except>
            ${fallbackHeadingHtml}
        </esi:except>
    </esi:try>`

    return esiWrapper
}
